import { Component } from '@angular/core';
import { LeafletStop } from '../core/stop';
import { Router } from '@angular/router';

@Component({
    selector: 'home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent {
    advantages = [
        {
            title: 'Инновационные трамваи',
            anchor: 'innovation',
            icon: 'fa-wifi',
            // description: 'Какое-то краткое описание инноваций хочет Виталич отобразить здесь'
            svg: './assets/innovative-tram.png'
        },
        {
            title: 'Бесплатный Wi-Fi в вагоне',
            anchor: 'wifi',
            icon: 'fa-wifi',
            // description: 'Вот что здесь можно написать про бесплатный вай фай. Оно и так понятно, что он бесплатный и что он есть в вагонах'
            svg: './assets/wifi.png'
        },
        {
            title: 'Комфортабельные остановки',
            anchor: 'stops',
            icon: 'fa-wifi',
            // description: 'Хм. остановки бывают комфортабельными? Ну разве что с кожаными диванчиками и телевизором для получения новостей в режиме нон-стоп'
            svg: './assets/stop.png'
        },
        {
            title: 'Удобные способы оплаты',
            anchor: 'paymentways',
            icon: 'fa-wifi',
            // description: 'Да их всего один - с помощью карт пластиковых. Ну Яндекс.Деньги еще может будут. Лучше написать "Оплата с помощью карт"'
            svg: './assets/credit.png'
        },
        {
            title: 'Бесшумные технологии',
            anchor: 'technology',
            icon: 'fa-wifi',
            // description: 'Круто. У трамвая будет своя личная полоса. В топку все эти машины, они теперь не должны побеспокоить высокотехнологичный способ передвижения'
            svg: './assets/mute.png'
        },
        {
            title: 'Удобная маршрутная сеть',
            anchor: 'routenet',
            icon: 'fa-wifi',
            // description: 'Круто. У трамвая будет своя личная полоса. В топку все эти машины, они теперь не должны побеспокоить высокотехнологичный способ передвижения'
            svg: './assets/route.png'
        },
        {
            title: 'Приоритетный проезд',
            anchor: 'priority',
            icon: 'fa-wifi',
            // description: 'Круто. У трамвая будет своя личная полоса. В топку все эти машины, они теперь не должны побеспокоить высокотехнологичный способ передвижения'
            svg: './assets/directions.png'
        },
        {
            title: 'Выделенная зона движения',
            anchor: 'motionzone',
            icon: 'fa-wifi',
            // description: 'Круто. У трамвая будет своя личная полоса. В топку все эти машины, они теперь не должны побеспокоить высокотехнологичный способ передвижения'
            svg: './assets/road.png'
        }
    ];

    arrivalStop: LeafletStop;
    departureStop: LeafletStop;

    isTripPayment: boolean = false;

    constructor(private router: Router) { }

    switchStop() {
        var value = this.departureStop;
        this.departureStop = this.arrivalStop;
        this.arrivalStop = value;
    }

    navigate() {
        if (this.departureStop && this.arrivalStop)
            this.router.navigate(['/interactive-map', { startStopId: this.departureStop.id, finishStopId: this.arrivalStop.id }]);
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/pages/home.component.ts